var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoDescargar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.166,
    height: 23,
    viewBox: "0 0 19.166 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_69581",
    "data-name": "Trazado 69581",
    d: "M1484.515,672.964l-3.338-3.341a6.669,6.669,0,0,0-4.744-1.965h-4.327a4.8,4.8,0,0,0-4.791,4.792v13.416a4.8,4.8,0,0,0,4.791,4.792h9.583a4.8,4.8,0,0,0,4.792-4.792v-8.16a6.664,6.664,0,0,0-1.966-4.744Zm-1.355,1.356a4.774,4.774,0,0,1,.771,1.006h-4.16a.959.959,0,0,1-.958-.958v-4.161a4.809,4.809,0,0,1,1.007.771l3.339,3.341Zm1.4,11.547a2.878,2.878,0,0,1-2.875,2.875h-9.583a2.878,2.878,0,0,1-2.875-2.875V672.451a2.878,2.878,0,0,1,2.875-2.875h4.327c.156,0,.312.007.465.022v4.77a2.879,2.879,0,0,0,2.875,2.875h4.769c.014.153.022.309.022.465v8.16Zm-4.114-2.774a.958.958,0,0,1,0,1.355L1478.9,686a2.841,2.841,0,0,1-4.013,0l-1.546-1.547a.958.958,0,0,1,1.355-1.355l1.239,1.239v-4.215a.958.958,0,0,1,1.917,0v4.215l1.239-1.239a.957.957,0,0,1,1.355,0Z",
    transform: "translate(-1467.315 -667.659)",
    fill: "#003763"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoDescargar);
export default __webpack_public_path__ + "static/media/Icono-Descargar.887830071ef5abb3d5887ce3d9ebda75.svg";
export { ForwardRef as ReactComponent };